import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { WeiterbildungsartService } from '../../../services/facetten/instance/weiterbildungsart.service';

import { CheckboxFacetteComponent } from '../../checkbox-facette/checkbox-facette.component';
import { FilterSelectItem } from '../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';
import { BildungsbereichService } from '../../../services/state/bildungsbereich.service';
import { map } from 'rxjs';
import { LoaderService } from '../../../services/loader.service';

@Component({
  selector: 'now-wbsuche-lib-weiterbildungsart-facette',
  templateUrl: './weiterbildungsart-facette.component.html',
  imports: [CheckboxFacetteComponent, BasisFacetteComponent, CommonModule]
})
export class WeiterbildungsartFacetteComponent {
  facettenService = inject(WeiterbildungsartService);
  private readonly bildungsbereichService = inject(BildungsbereichService);
  loaderService = inject(LoaderService);

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService.getSelectItems$();
  public modalId$ = this.bildungsbereichService.isUte$.pipe(
    map((isUte) => (isUte ? 'weiterbildungsart-ute' : 'weiterbildungsart'))
  );

  public updateSelectedIds(selectedItems: FilterSelectItem[]): void {
    const selectedIds = selectedItems.map((item) => item.key);
    this.facettenService.updateSelectedIds(selectedIds);
  }
}
